import { alereAxios } from '../utils/api';

export const getPaymentMethodForAutocomplete = (search) =>
  alereAxios.get('orders/payments/methods', {
    params: { pageSize: 10, page: 1, search },
  });
